import { WidgetTagsResponse } from '@core/dashboard-types';
import { createSingleEntityStore } from '@core/ngrx-legacy';

const { namespace, actions, reducer, selectors } =
  createSingleEntityStore<WidgetTagsResponse>()('TagsSources');

export {
  namespace as DashboardTagsSourcesNamespace,
  actions as DashboardTagsSourcesActions,
  reducer as DashboardTagsSourcesReducer,
  selectors as DashboardTagsSourcesSelectors,
};
